<template>
  <div class="page faq-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">关于产品、购买和联系方式的常见问题，这里先给出我们最常被问到的答案。</p>
    <ContactFriend placement="hero" />
    <section v-for="faq in faqs" :key="faq.question" class="faq-item">
      <h2>{{ faq.question }}</h2>
      <p>{{ faq.answer }}</p>
    </section>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/faq.html')

const FAQS = [
  {
    question: '滋仙草官网是哪个域名？',
    answer: '官方网站是 www.zixiancao.com，站内的品牌故事、产品、品质信息、常见问题和联系方式都在这个域名下。'
  },
  {
    question: '产品规格、配料和生产信息在哪里看？',
    answer:
      '每一款产品都有独立详情页，照录了包装标签上的净含量、配料、产品类型、保质期、贮存条件、产地与食用方法，' +
      '匠心产品页还有一张横向对照表可以直接比较各规格。批次相关的生产信息请以收到的实物包装为准。'
  },
  {
    question: '怎样联系企业顾问？',
    answer: '页面顶部的“加好友”按钮和各页的加好友入口都可以直接打开企业微信，联系页还有服务热线与商务合作邮箱。'
  },
  {
    question: '原浆产品有哪几款？',
    answer:
      '目前公开参数的有六款：紫皮石斛原浆礼盒装（210mL）、紫皮石斛原浆量贩装（900mL）、' +
      '铁皮石斛原浆礼盒装（210mL）、铁皮石斛原浆量贩装（900mL）、有机天麻原浆礼盒装（210mL，30mL×7 袋）' +
      '与有机天麻原浆量贩装（900mL，30mL×30 袋）。都可以在匠心产品页查看参数与食用方法。'
  },
  {
    question: '紫皮石斛与铁皮石斛两种原浆有什么区别？',
    answer:
      '两者原料品种不同：紫皮石斛原浆用紫皮石斛浆，铁皮石斛原浆用铁皮石斛浆，其余配料都是木糖醇，' +
      '产品类型同为植物饮料，保质期与贮存条件一致。具体含量标示值请分别看对应产品页，本站不在两个品种之间比较高低。'
  },
  {
    question: '盒装和量贩装要怎么选？',
    answer:
      '同一品种的盒装为 210mL（30mL×7 袋），量贩装为 900mL（30mL×30 袋），配料、保质期与食用方法相同，' +
      '差别在于单次购买量与携带方式。天麻原浆同样是盒装 210mL、量贩装 900mL。'
  },
  {
    question: '有不适人群或食用上的注意事项吗？',
    answer:
      '两款原料各有包装标示的注意事项：婴幼儿、孕妇、乳母不宜食用；包装破损或胀袋请勿饮用；' +
      '本品有少量沉淀属正常现象。石斛系列建议喝前摇一摇、避免微波炉加热；天麻原浆饮包装建议每日食用 2-4 袋。' +
      '各款完整提示见对应产品页的“温馨提示”。'
  },
  {
    question: '价格与购买渠道在哪里？',
    answer: '官网不展示价格。当期价格、活动与购买渠道以官方店铺信息为准，也可以咨询企业顾问。'
  }
]

export default {
  name: 'FaqPage',
  components: {
    ContactFriend
  },
  data() {
    return { page, faqs: FAQS }
  }
}
</script>

<style scoped>
.page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

.faq-item {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.06);
  margin-top: 14px;
}

.faq-item h2 {
  color: #4b0082;
  font-size: 1.05em;
  margin: 0 0 6px;
}

.page-intro,
.faq-item p {
  color: #333;
  line-height: 1.8;
  margin: 0;
}
</style>
